import { render, staticRenderFns } from "./CmgCreateAccountForm.vue?vue&type=template&id=39433dd0&scoped=true&lang=pug&"
import script from "./cmg-create-account-form.ts?vue&type=script&lang=ts&"
export * from "./cmg-create-account-form.ts?vue&type=script&lang=ts&"
import style0 from "./CmgCreateAccountForm.vue?vue&type=style&index=0&id=39433dd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39433dd0",
  null
  
)

export default component.exports